/* eslint-disable no-shadow */
const state = {
	wishlistProducts: []
}

const getters = {
	getWishListIds: (state) => {
		if (state.wishlistProducts && state.wishlistProducts.length > 0) {
			return state.wishlistProducts
		}
		return []
	},
	getWishlistProducts: state => state.wishlistProducts,
	getWishlistCount: state => state.wishlistProducts.length,
	isInWishlist: state => productId =>
		state.wishlistProducts.filter(product => product === productId).length > 0
}

const mutations = {
	mutateUpdateWishlist: (state, payload) => {
		state.wishlistProducts.push(payload)
	},
	mutateAddToWishlist: (state, payload) => {
		const products =
      state.wishlistProducts.filter(product => product === payload)
		if (products.length === 0) {
			state.wishlistProducts.push(payload)
		}
	},
	mutateDeleteFromWishlist: (state, payload) => {
		const index = state.wishlistProducts
			.findIndex(product => product === payload)
		state.wishlistProducts.splice(index, 1)
	},

	mutateEmptyWishlist: (state) => {
		state.wishlistProducts = []
	}
}

const actions = {
	updateWishlist: ({
		commit
	}, payload) => {
		commit('mutateUpdateWishlist', payload)
	},
	addToWishlist: ({
		commit
	}, payload) => {
		commit('mutateAddToWishlist', payload)
	},
	deleteFromWishlist: ({
		commit
	}, payload) => {
		commit('mutateDeleteFromWishlist', payload)
	},
	emptyWishlist: ({
		commit
	}) => {
		commit('mutateEmptyWishlist')
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
